module.exports = __webpack_public_path__ + "img/animals_05_V.cb5c4809.webp";